import React, { useState, useEffect } from "react";
import { Select, Checkbox } from "antd";
import { forms } from "../../views/medicines/AddMedicine";
import { getCompanies } from "../../apis/company";
import { Company } from "../../interfaces/Company";
import { savePharmacyItem, updatePharmacyItem } from "../../apis/pharmacyItems";
import { PharmacyItem } from "../../interfaces/PharmacyItems";


const { Option } = Select;
type AddPharmacyItemProps = {
  closeModal: () => void;
  editableItem?: any;
};

const AddPharmacyItem: React.FC<AddPharmacyItemProps> = ({ closeModal, editableItem }) => {
  const [companies, setCompanies] = useState<Company[]>([]);
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const isEditMode = Boolean(editableItem?.id);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState<PharmacyItem>({
    name: "",
    sku: "",
    barcode: "",
    molecule: "",
    company_id: "",
    company:"",
    form: "",
    strength: "",
    unit: "",
    description: "",
    is_active: true,
    is_consumable: true,
  });

  useEffect(() => {
    fetchCompanies();
  }, []);

  useEffect(() => {
  if (editableItem) {
    setFormData({
      name: editableItem.name,
      sku: editableItem.sku,
      barcode: editableItem.barcode,
      molecule: editableItem.molecule,
      company_id: editableItem.companyId, 
      company: editableItem.company, 
      form: editableItem.form,
      strength: editableItem.strength,
      unit: editableItem.unit,
      description: editableItem.description,
      
      is_active: editableItem.isActive ?? true,
      is_consumable: editableItem.isConsumable ?? true,
    });
  } else {
    setFormData({
      name: "",
      sku: "",
      barcode: "",
      molecule: "",
      company_id: "",
      company: "",
      form: "",
      strength: "",
      unit: "",
      description: "",
      is_active: true,
      is_consumable: true,
    });
  }
}, [editableItem]);

  const fetchCompanies = () => {
    getCompanies({}).then((res: any) => {
      setCompanies(res.data);
    });
  };

  const handleChange = (field: string, value: any) => {
    setFormData({ ...formData, [field]: value });
    setErrors({ ...errors, [field]: "" });
  };

  const validateForm = () => {
    const e: { [key: string]: string } = {};
    if (!formData.name) e.name = "* Name is required";
    if (!formData.company_id) e.company_id = "* Company is required";
    if (!formData.unit) e.unit = "* Unit is required";
    if (!formData.sku) e.sku = "* SKU is required";

    setErrors(e);
    return Object.keys(e).length === 0;
  };

const onSave = async () => {
  if (!validateForm()) return;

  setLoading(true);
  try {
    if (isEditMode) {
      await updatePharmacyItem(editableItem.id, formData);
    } else {
      await savePharmacyItem(formData);
    }
    closeModal();
  } catch (err) {
    console.error(err);
  } finally {
    setLoading(false);
  }
};

  const inputClass =
    "block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6";

  return (
    <div>
      <div className="grid grid-cols-1 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-900">Name</label>
          <input
            type="text"
            value={formData.name}
            onChange={(e) => handleChange("name", e.target.value)}
            className={inputClass}
          />
          {errors.name && <span className="text-red-500 text-sm">{errors.name}</span>}
        </div>

        <div className="grid grid-cols-3 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-900">Barcode</label>
            <input
              type="text"
              value={formData.barcode}
              onChange={(e) => handleChange("barcode", e.target.value)}
              className={inputClass}
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-900">SKU</label>
            <input
              type="text"
              value={formData.sku}
              onChange={(e) => handleChange("sku", e.target.value)}
              className={inputClass}
            />
            {errors.sku && <span className="text-red-500 text-sm">{errors.sku}</span>}
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-900">Unit</label>
            <input
              type="text"
              value={formData.unit}
              onChange={(e) => handleChange("unit", e.target.value)}
              className={inputClass}
            />
            {errors.unit && <span className="text-red-500 text-sm">{errors.unit}</span>}
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4 pt-2">
          <div>
            <label className="block text-sm font-medium text-gray-900">Company</label>
            <Select
              style={{ width: "100%" }}
              value={formData.company_id}
              onChange={(value) => handleChange("company_id", value)}
              allowClear
            >
              {companies.map((company) => (
                <Option key={company.id} value={company.id}>
                  {company.name}
                </Option>
              ))}
            </Select>
            {errors.company_id && <span className="text-red-500 text-sm">{errors.company_id}</span>}
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-900">Molecule</label>
            <input
              type="text"
              value={formData.molecule}
              onChange={(e) => handleChange("molecule", e.target.value)}
              className={inputClass}
            />
            {errors.molecule && <span className="text-red-500 text-sm">{errors.molecule}</span>}
          </div>
        </div>


        <div className="grid grid-cols-2 gap-4 pt-2">
          <div>
            <label className="block text-sm font-medium text-gray-900">Form</label>
            <Select
              placeholder="Select Form"
              value={formData.form}
              onChange={(val) => handleChange("form", val)}
              className="w-full"
            >
              {forms.map((f) => (
                <Option key={f.value} value={f.value}>
                  {f.name}
                </Option>
              ))}
            </Select>
            {errors.form && <span className="text-red-500 text-sm">{errors.form}</span>}
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-900">Strength</label>
            <input
              type="text"
              value={formData.strength}
              onChange={(e) => handleChange("strength", e.target.value)}
              className={inputClass}
            />
            {errors.strength && <span className="text-red-500 text-sm">{errors.strength}</span>}
          </div>
        </div>

        <div className="flex gap-4 items-center">
          <Checkbox
            checked={formData.is_consumable}
            onChange={(e) => handleChange("is_consumable", e.target.checked)}
          >
            Is Consumable
          </Checkbox>
          <Checkbox
            checked={formData.is_active}
            onChange={(e) => handleChange("is_active", e.target.checked)}
          >
            Is Active
          </Checkbox>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-900">Description</label>
          <textarea
            rows={4}
            value={formData.description}
            onChange={(e) => handleChange("description", e.target.value)}
            className={inputClass}
          />
          {errors.description && <span className="text-red-500 text-sm">{errors.description}</span>}
        </div>
      </div>

      <div className="flex gap-4 mt-4">
        <button
          onClick={onSave}
          type="button"
          disabled={loading}
          className="px-3 py-2 bg-primary hover:bg-hover text-white rounded-md disabled:opacity-50"
        >
          {loading ? (isEditMode ? "Updating..." : "Saving...") : isEditMode ? "Update" : "Save"}
        </button>
        <button
          onClick={closeModal}
          type="button"
          className="text-sm font-semibold leading-6 text-gray-900"
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export default AddPharmacyItem;
